import { render, staticRenderFns } from "./Clean.vue?vue&type=template&id=0987a1ac"
import script from "./Clean.vue?vue&type=script&lang=js"
export * from "./Clean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports